<template>
  <div class="home">
    <front-cover></front-cover>
    <div class="transition"></div>
    <div class="thisis">
      <div class="thisis-container">
          <img class="thisis-logo" src="@/assets/thisis.png" />
          <p class="thisis-text">Reidar Edvin Sandanger er en av drøyt 1100 personer som er blitt sporløst borte i Norge. Men  Reidars sak er spesiell. Noen sendte meldinger i hans navn lenge etter at han ble borte. Både familie og etterforskere frykter at trebarnsfaren ble drept. Så hvorfor gjorde ikke politiet i to land mer for å finne svar? Og hva skjedde egentlig med Reidar?</p>
          <p v-if="$store.state.provider == 'sa'" class="thisis-text">På denne siden kan du høre episodene, lese mer om folkene i serien og utforske ekstramaterialet til hver episode.</p>
          <p v-if="$store.state.provider != 'sa'" class="thisis-text">På denne siden kan du høre episodene, lese mer om folkene i serien og utforske ekstramaterialet til hver episode. Podkasten er produsert av Stavanger Aftenblad.</p>
          <p v-if="$store.state.provider == 'sa'" class="thisis-text">Vil du vite mer om hvor du kan lytte til denne podkasten? <a class="thisis-link" href="https://aftenbladet.no/i/nAvzAa">Her forklarer vi hvordan du kan lytte til podkast fra Aftenbladet.</a></p>
          <p v-if="$store.state.provider == 'bt'" class="thisis-text">Vil du vite mer om hvor du kan lytte til denne podkasten? <a class="thisis-link" href="https://bt.no/i/WO7xGd/">Her forklarer vi hvordan du kan lytte til podkast fra BT.</a></p>
          <!-- <p v-if="$store.state.provider == 'others'" class="thisis-text">Vil du vite mer om hvor du kan lytte til denne podkasten? <a class="thisis-link" href="https://bt.no/i/WO7xGd/">Her forklarer vi hvordan du kan lytte til podkast fra BT.</a></p> -->
        </div>
    </div>
    <div class="page-container" id="content-start">
      <sticky-navigation></sticky-navigation>
      <!-- <div class="page-content"> 
        </div> -->
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Home",
    data: function(){
      return {
        visible: true 
      }
    }
};
 
</script>

<style lang="scss" scoped>
.transition {
  position: relative;
  -webkit-transform: translate3d(0, 0, 1px);
  transform: translate3d(0, 0, 1px);
  z-index: 10;
  height: 5em;
  margin-top: -5em;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#1f1d1b+0,000000+100&1+0,0+100 */
  background: -moz-linear-gradient(
    0deg,
    rgb(27, 28, 30) 0%,
    rgba(0, 0, 0, 0) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    0deg,
    rgba(27, 28, 30, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    0deg,
    rgba(27, 28, 30, 1) 0%,
    rgba(0, 0, 0, 0) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#1f1d1b', endColorstr='#00000000',GradientType=1 ); /* IE6-9 fallback on horizontal gradient */
}

.thisis {
  margin: -2rem 1rem 0;
  position: relative;
  -webkit-transform: translate3d(0, 0, 1px);
  transform: translate3d(0, 0, 1px);

  z-index: 15;

  &-container {
  max-width: calc(700px - 2rem);
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 3rem;
  padding: 1rem;
  position: relative;
  border: 1px solid #fff;  
    @include desktop() {
      max-width: calc(700px - 4rem);
      padding: 2rem;
    }
  }
  
  .thisis-logo {
    position: absolute;
    -webkit-transform: translate3d(0, 0, 1px);
    transform: translate3d(0, 0, 1px);
    z-index: 15;
    height: 50px;
    color: #fff;
    top: -28px;
    text-align: center;
    margin: 0;
    transform: translateX(-50%);
    left: 50%;
        @include desktop() {
          height: 55px;
        }
    
    }

  &-text {
    color: #fff;
    text-align: center;
    line-height: 1.4;
    font-size: 1.1em;
    margin: 1rem 0;
  }
  &-link {
    color: #fff;
    text-decoration: underline;
  }
}

</style>